import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Carousel = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  const mediaButtonStyle = {
    background: "transparent",
    border: 0,
    display: "block",
    padding: 0,
    textAlign: "left",
    width: "100%",
  };
  return (
    <section className="section shadow-sm lazyloaded" id="Gallery">
      <span className="section-link"></span>{" "}
      <div className="row">
        <div className="col-md-8">
          <h2 className="head text-capitalize">{project} - Gallery</h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale float-lg-right mx-sm-auto  d-none d-lg-block"
            onClick={handleShowModal}
          >
            Download Gallery
          </button>
        </div>
      </div>
      <div className="owl-carousel-img owl-carousel owl-theme gallery-img">
        <div className="at-property-item">
          <button
            type="button"
            data-fancybox="gallery-0"
            className="at-property-img"
            onClick={handleShowModal}
            style={mediaButtonStyle}
          >
            {" "}
            <img
              data-src="../images/lntevaraheights-Gallery-Banquet.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/lntevaraheights-Gallery-Banquet.webp"
              alt={`${project} banquet gallery preview`}
            />
            <div className="at-property-overlayer"></div>
            <span className="btn btn-default at-property-btn">
              View Gallery
            </span>
          </button>
        </div>
        <div className="at-property-item">
          <button
            type="button"
            data-fancybox="gallery-0"
            className="at-property-img"
            onClick={handleShowModal}
            style={mediaButtonStyle}
          >
            {" "}
            <img
              data-src="../images/lntevaraheights-Gallery-Bedroom.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/lntevaraheights-Gallery-Bedroom.webp"
              alt={`${project} bedroom gallery preview`}
            />
            <div className="at-property-overlayer"></div>
            <span className="btn btn-default at-property-btn">
              View Gallery
            </span>
          </button>
        </div>
        <div className="at-property-item">
          <button
            type="button"
            data-fancybox="gallery-0"
            className="at-property-img"
            onClick={handleShowModal}
            style={mediaButtonStyle}
          >
            {" "}
            <img
              data-src="../images/lntevaraheights-Gallery-Co-Working-Pods.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/lntevaraheights-Gallery-Co-Working-Pods.webp"
              alt={`${project} co-working pods gallery preview`}
            />
            <div className="at-property-overlayer"></div>
            <span className="btn btn-default at-property-btn">
              View Gallery
            </span>
          </button>
        </div>
        <div className="at-property-item">
          <button
            type="button"
            data-fancybox="gallery-0"
            className="at-property-img"
            onClick={handleShowModal}
            style={mediaButtonStyle}
          >
            {" "}
            <img
              data-src="../images/lntevaraheights-Gallery-Creche.webp"
              loading="lazy"
              className="gallery-thumb ls-is-cached lazyloaded"
              src="images/lntevaraheights-Gallery-Creche.webp"
              alt={`${project} creche gallery preview`}
            />
            <div className="at-property-overlayer"></div>
            <span className="btn btn-default at-property-btn">
              View Gallery
            </span>
          </button>
        </div>
      </div>
      <div className="col-12">
        <button
          className="chat-btn btn btn-info micro-form-btn enqModal effetGradient effectScale float-lg-right mx-sm-auto d-lg-none"
          data-form="lg"
          data-title="Download Gallery"
          data-btn="Send Now"
          data-enquiry="Download Gallery"
          data-redirect="floorplan"
          data-toggle="modal"
          data-target="#enqModal"
          onClick={handleShowModal}
        >
          Download Gallery
        </button>
      </div>
    </section>
  );
};

export default Carousel;
